import { Alert } from '@prisma/client';
import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@zond/ui';
import { MoreHorizontal, Pencil, Trash } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAlerts } from '../context/alerts-context';

interface AlertActionsProps {
  alert: Alert;
}

export function AlertActions({ alert }: AlertActionsProps) {
  const { t } = useTranslation('alerts');
  const { setOpen, setSelectedAlert } = useAlerts();

  const handleEdit = () => {
    setSelectedAlert(alert);
    setOpen('edit');
  };

  const handleDelete = () => {
    setSelectedAlert(alert);
    setOpen('delete');
  };

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="h-8 w-8 p-0">
          <span className="sr-only">{t('actions.openMenu')}</span>
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={handleEdit}>
          <Pencil className="mr-2 h-4 w-4" />
          {t('common:actions.edit')}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleDelete}>
          <Trash className="mr-2 h-4 w-4" />
          {t('common:actions.delete')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
